import Modal from "react-modal";

const DeleteConfirmModal = ({
  text = "Are you sure?",
  isOpen,
  onRequestClose,
  onDelete,
  overlayStyle = {
    background: "rgba(7, 21, 43, 0.7)",
    zIndex: 10,
  },
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Delete Confirmation Modal"
      className="insight-delete-modal modal-shape d-flex flex-column align-items-center justify-content-around"
      appElement={document.getElementById("root")}
      style={{
        overlay: overlayStyle,
      }}
    >
      <h4 className="text-center">{text}</h4>
      <div className="d-flex justify-content-center insight-delete-button-height">
        <button
          type="button"
          className="btn-primary me-3"
          onClick={() => {
            onDelete();
            onRequestClose();
          }}
        >
          Delete
        </button>
        <button
          type="button"
          className="btn-secondary"
          onClick={onRequestClose}
        >
          Cancel
        </button>
      </div>
    </Modal>
  );
};

export default DeleteConfirmModal;
